"use strict";

var t = function t(_t) {
  var a = _t.value,
    e = _t.finalLength,
    r = void 0 === e ? 2 : e;
  return a.toString().padStart(r, "0");
};
exports.addLeadingZeros = t, exports.dateToObject = function (a) {
  var e = a.getDate(),
    r = a.getMonth() + 1,
    n = a.getFullYear();
  return {
    day: e,
    month: r,
    year: n,
    formatted: "".concat(t({
      value: e
    }), "/").concat(t({
      value: r
    }), "/").concat(n)
  };
};